import type { Filter } from '~/api/seller-after-sales/types/requests.types'

import translations from './Filters.translations'

export const FILTERS_LIST = {
  status: {
    label: translations.status,
    name: 'status',
  },
  taskTypes: {
    label: translations.task,
    name: 'taskTypes',
  },
  orderId: {
    label: translations.orderId,
    name: 'orderId',
  },
  customerFirstName: {
    label: translations.customerFirstName,
    name: 'customerFirstName',
  },
  customerLastName: {
    label: translations.customerLastName,
    name: 'customerLastName',
  },
  markets: {
    label: translations.market,
    name: 'markets',
  },
  sku: {
    label: translations.sku,
    name: 'sku',
  },
}

export const MULTISELECT_FILTERS = [
  FILTERS_LIST.status,
  FILTERS_LIST.taskTypes,
  FILTERS_LIST.markets,
]

export const MULTISELECT_FILTERS_NAMES = MULTISELECT_FILTERS.map(
  (filter) => filter.name,
)
export const VALID_ORDER_NUMBER_REGEXP = /^\d+$/

export const EMPTY_FILTERS_VALUES: Filter = {
  status: [],
  taskTypes: [],
  orderId: '',
  customerFirstName: '',
  customerLastName: '',
  markets: [],
  sku: '',
}
